export const state = {
  changeThumbnailPhotograph: '',
  addUser: {},
  updateUser: {},
  changePassword: {
    userId: '',
    pronunciation: '',
    familyName: '',
    name: '',
    postId: '',
    postName: '',
    birthday: '',
    job: '',
    position: '',
    thumbnailPhotograph: '',
    passwordToken: ''
  },
  careworker: {
    userId: '',
    pronunciation: '',
    familyName: '',
    name: '',
    postId: '',
    postName: '',
    birthday: '',
    job: '',
    position: '',
    thumbnailPhotograph: '',
    passwordToken: ''
  },
  careworkers: [],
  posts: [],
  selectedposts: [],
  jobs: [],
  fileDownloadErrorFlg: false,
  exportData: [],
  total: 0,
  selectedCareworkerList: []
}
export const mutations = {
  setCareworkers(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
      state.total = 0
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      if (
        state.selectedCareworkerList.some(
          (selectedCareworker) =>
            selectedCareworker.userId === response.data['data'][i]['userId']
        )
      ) {
        response.data['data'][i]['checked'] = true
      } else {
        response.data['data'][i]['checked'] = false
      }
    }
    state.careworkers = response.data['data']
    state.total = response.data['header']['total']
  },
  setPosts(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      response.data['data'][i]['checked'] = false
    }
    state.posts = response.data['data']
  },
  setExportData(state, response) {
    state.exportData = response.data['data']
  },
  clearExportData(state) {
    state.exportData = []
  },
  setDetail(state, response) {
    for (var i in response.data['data']) {
      if (response.data['data'][i] === null) {
        response.data['data'][i] = ''
      }
    }
    state.careworker = response.data['data'][0]
    state.changePassword = response.data['data'][0]
    state.updateUser = {}
    state.updateUser.userId = state.careworker.userId
  },
  setSelectedPosts(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      response.data['data'][i]['checked'] = false
    }
    state.selectedposts = response.data['data']
  },
  setJobs(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      response.data['data'][i] = {
        job: response.data['data'][i],
        checked: false
      }
    }
    state.jobs = response.data['data']
  },
  inputUpdate(state, payload) {
    state.updateUser[payload.name] = payload.value
  },
  inputAddUpdate(state, payload) {
    state.addUser[payload.name] = payload.value
  },
  clearCareworker(state) {
    state.addUser = {}
  },
  deletePassword(state) {
    state.changePassword['passwordToken'] = ''
  },
  setUpdatePostId(state) {
    if (state.updateUser.postName) {
      for (var i = 0; i < state.selectedposts.length; i++) {
        if (state.selectedposts[i].postName === state.updateUser.postName) {
          state.updateUser.postId = state.selectedposts[i].postId
          break
        }
      }
    }
  },
  setAddPostId(state) {
    for (var i = 0; i < state.selectedposts.length; i++) {
      if (state.selectedposts[i].postName === state.addUser.postName) {
        state.addUser.postId = state.selectedposts[i].postId
        break
      }
    }
  },
  changeUpdateUserBirthday(state, payload) {
    state.updateUser.birthday = payload
    if (state.updateUser.foothold === '') {
      state.updateUser.foothold = false
    }
  },
  changeAddUserBirthday(state, payload) {
    state.addUser.birthday = payload
    if (state.addUser.foothold === '') {
      state.addUser.foothold = false
    }
  },
  async fileDownload(state, response) {
    var reader = new FileReader()
    await reader.readAsDataURL(response.data)
    reader.onloadend = () => {
      state.changeThumbnailPhotograph = reader.result
    }
  },
  fileDownloadErrorFlg(state, payload) {
    state.fileDownloadErrorFlg = payload
  },
  updateSelectedCareworkerList(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      if (
        payload[i].checked &&
        !state.selectedCareworkerList.some(
          (user) => user.userId === payload[i].userId
        )
      ) {
        state.selectedCareworkerList.push(payload[i])
      } else if (
        !payload[i].checked &&
        state.selectedCareworkerList.some(
          (user) => user.userId === payload[i].userId
        )
      ) {
        const deleteIndex = state.selectedCareworkerList.findIndex(
          (user) => user.userId === payload[i].userId
        )
        state.selectedCareworkerList = state.selectedCareworkerList.toSpliced(
          deleteIndex,
          1
        )
      }
    }
  },
  clearSelectedCareworkerList(state) {
    state.selectedCareworkerList = []
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/careworkerModules/careworkerMutation.js